export default __webpack_public_path__ + "static/media/Head_1_Ear_3_C1.261b965a.svg";